// Table of content
// /!\ Need id attribute on h2

import '@/src/sass/5-layouts/_tableofcontent.scss';

const slugify = (str) => {
    str = str.replace(/^\s+|\s+$/g, ''); // trim
    str = str.toLowerCase().trim();

    // remove accents, swap ñ for n, etc
    let from = "àáäâèéëêìíïîòóöôùúüûñçěščřžýúůďťň·/_,:;";
    let to = "aaaaeeeeiiiioooouuuuncescrzyuudtn------";

    for (let i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i));
    }

    return str.replace('.', '-') // replace a dot by a dash
        .replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by a dash
        .replace(/-+/g, '-') // collapse dashes
        .replace(/\//g, '') // collapse all forward-slashes
        .replace(/\-$/g, '') // remove trailing dash
    ;
}

$(document).ready(function () {
    $('.post h2').each(function () {
        $(this).attr('id', slugify($(this).text()));
    });
    $("#toc-content").change(function() {
        $("#toc-title").toggleClass("toc-show", this.checked)
    }).change();

});